import React from 'react';

// Individual badge components for each material type
export const VideoBadge = () => (
  <div className="px-2 py-1 bg-emerald-700 rounded inline-flex justify-center items-center gap-2.5">
    <div className="text-center justify-start text-white text-xs font-normal uppercase leading-none">Video</div>
  </div>
);

export const PDFBadge = () => (
  <div className="px-2 py-1 bg-purple-700 rounded inline-flex justify-center items-center gap-2.5">
    <div className="text-center justify-start text-white text-xs font-normal uppercase leading-none">PDF</div>
  </div>
);

export const TextBookBadge = () => (
  <div className="px-2 py-1 bg-orange-700 rounded inline-flex justify-center items-center gap-2.5">
    <div className="text-center justify-start text-white text-xs font-normal uppercase leading-none">Text Book</div>
  </div>
);

export const AudioBadge = () => (
  <div className="px-2 py-1 bg-blue-700 rounded inline-flex justify-center items-center gap-2.5">
    <div className="text-center justify-start text-white text-xs font-normal uppercase leading-none">Audio</div>
  </div>
);

// Main component that returns the appropriate badge based on material type
const StudyMaterialsBadge = ({ type }) => {
  switch (type.toLowerCase()) {
    case 'video':
      return <VideoBadge />;
    case 'pdf':
      return <PDFBadge />;
    case 'text book':
      return <TextBookBadge />;
    case 'audio':
      return <AudioBadge />;
    default:
      return <span>{type}</span>;
  }
};

export default StudyMaterialsBadge;